import React from 'react';
import PropTypes from 'prop-types';
import AddressInput from './AddressField/AddressInput/AddressInput';
import AddressDropDown from './AddressField/AddressDropDown/AddressDropDown';

const ADDRESS_INPUT = 'ADDRESS_INPUT';
const ADDRESS_DROPDOWN = 'ADDRESS_DROPDOWN';

function AddressFieldItem({ field, value, onChange }) {
  const {
    component, name, label, placeholder, required, options,
  } = field;

  // Extract label text from either string or object format
  const labelText = typeof label === 'string' ? label : label?.value || '';

  const handleChange = (e) => {
    const newValue = e.target ? e.target.value : e;
    onChange(name, newValue);
  };

  if (component === ADDRESS_INPUT) {
    return (
      <AddressInput
        name={name}
        value={value}
        label={labelText}
        placeholder={placeholder}
        onChange={handleChange}
        isRequired={required}
      />
    );
  }

  if (component === ADDRESS_DROPDOWN) {
    return (
      <AddressDropDown
        name={name}
        value={value}
        label={labelText}
        placeholder={placeholder}
        onChange={handleChange}
        isRequired={required}
        optionList={options}
      />
    );
  }

  // Return null for unsupported component types
  return null;
}

AddressFieldItem.propTypes = {
  field: PropTypes.shape({
    component: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
      }),
    ]),
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          value: PropTypes.string,
          text: PropTypes.string,
          label: PropTypes.string,
          optionValue: PropTypes.string,
        }),
      ]),
    ),
  }),
  value: PropTypes.string,
  onChange: PropTypes.func,
};

AddressFieldItem.defaultProps = {
  field: {
    component: ADDRESS_INPUT,
    name: '',
    label: '',
    placeholder: '',
    required: false,
    options: [],
  },
  value: '',
  onChange: () => {},
};

export const addressFieldProp = PropTypes.shape({
  component: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ]),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        text: PropTypes.string,
        label: PropTypes.string,
        optionValue: PropTypes.string,
      }),
    ]),
  ),
});

export default AddressFieldItem;
